import styled from "styled-components";

type DividerBaseProps = {
  $margin?: string;
  $color?: string;
};

const Divider = styled.div<DividerBaseProps>`
  background-color: ${({ $color, theme }) =>
    $color ?? theme.colors.neutral.light};
  margin: ${({ $margin }) => $margin};
`;

export const Horizontal = styled(Divider)`
  height: 1px;
  width: 100%;
`;

export const Vertical = styled(Divider)`
  height: auto;
  width: 1px;
`;
